import type { AnySceneObjectT } from "tweenly"
import { PayloadObjT } from "./objectTypes"

export const objectNodeUpdate = (stateObject: any, action: PayloadObjT): AnySceneObjectT => {
    return {
        ...stateObject,
        [action.property]: action.value,
    }
}
